import { gql } from 'apollo-boost';
import { QUOTED_URL_META_FIELDS } from './quoted-url-meta-fields';
import { FOLDER_CACHE_SAFE_FIELDS } from '../folder/cache-safe-folder-fields';

export const MESSAGE_REPLY_PREVIEW_FRAGMENT = gql`
    fragment MessageReplyPreview on Message {
        id
        title
        body
        laneKind
        aiRole
        folder {
                ...FolderCacheSafeFields
            }
        image {
            url
            cdn_url
            thumbnail {
                sm
                md
                lg
            }
            name
            displayName
            type
        }
        file {
            url
            cdn_url
            thumbnail {
                sm
                md
                lg
            }
            name
            displayName
            type
            mime
        }
        urlMeta {
            title
            description
            url
            article_url
            article_body
            article_pull_provider
            reddit_comments {
                author
                body
                score
                created_utc
                permalink
            }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
            image
            image_cdn_url
            image_name
            public_id
            gallery_images
            media_url
            media_type
            media_cdn_url
            media_hls_url
            publisher
            author
            author_image
            author_image_cdn_url
            author_image_original
            author_image_public_id
            author_image_name
            thumbnail {
                sm
                md
                lg
                xl
                original
            }
            author_image_thumbnail {
                sm
                md
                lg
            }
            ${QUOTED_URL_META_FIELDS}
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;